export default __webpack_public_path__ + "static/media/picture_Pro_robot.67fbf054.png";